<template>
  <div class="relative p-4">
    <div class="border border-blue-200 bg-white p-4 dark-bg-custom">
      <p class="font-semibold mb-0">
        Added phone numbers
      </p>
      <v-divider class="my-4"></v-divider>
      <div class="grid grid-cols-3 gap-4 w-full">
        <div v-for="(phoneNumber, index) in phoneNumbers" :key="index" class="h-14 flex w-full items-center gap-4 border rounded-md p-2">
          <p class="mb-0 font-semibold text-xl text-gray-700"><span class="text-blue-900">{{ phoneNumber.phoneNumber }}</span></p>
          <div class="flex items-center justify-end gap-2">
            <v-btn icon :color="$vuetify.theme.currentTheme.primary"
              @click="onEditNumberClick(phoneNumber)">
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn icon color="red" @click="onDeleteNumberClick(phoneNumber)">
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="absolute right-4 -top-11">
      <v-btn
        @click="onAddNumberClick"
        :color="$vuetify.theme.currentTheme.primary"
        class="white--text"
      >
        Add number
      </v-btn>
    </div>
    <v-dialog v-model="addNumberDialogVisible" max-width="500px">
      <v-card :color="$vuetify.theme.currentTheme.navigationColor">
        <v-card-title>
          Add phone number
        </v-card-title>
        <v-card-text>
          <v-form
            :model="newNumberFields"
            :rules="newNumberFieldsRules"
            ref="newNumberFieldsRef"
          >
            <v-text-field
              v-model="newNumberFields.phoneNumber"
              label="Phone number"
              :rules="newNumberFieldsRules.phoneNumber"
              required
            />
            <v-text-field
              v-model="newNumberFields.userName"
              label="Username"
              :rules="newNumberFieldsRules.userName"
              required
            />
            <v-text-field
              v-model="newNumberFields.passWord"
              label="Password"
              :rules="newNumberFieldsRules.passWord"
              required
              type="password"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="addNumberDialogVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :color="$vuetify.theme.currentTheme.primary"
            class="white--text"
            @click="addNumber"
            :loading="addingNumber"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialogVisible"
      persistent
      width="380px"
    >
      <div class="bg-white dark-bg-custom p-4">
        <p class="text-lg font-bold">Do you want to delete this phone number?</p>
        <div class="flex items-center justify-end gap-2">
          <v-btn
            text
            color="red"
            @click="deleteDialogVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :color="$vuetify.theme.currentTheme.primary"
            class="white--text"
            @click="deleteNumber(deleteDialogVisiblePhoneNumber)"
            :loading="deletingNumber"
          >
            <span class="text-white"> OK </span>
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <v-dialog
      v-model="editDialogVisible"
      persistent
      width="380px"
    >
      <div class="bg-white dark-bg-custom p-4">
        <p class="text-lg font-bold">Edit phone number</p>
        <v-form
          :model="newNumberFields"
          :rules="newNumberFieldsRules"
        >
          <v-text-field
            v-model="newNumberFields.userName"
            label="Username"
            :rules="newNumberFieldsRules.userName"
            required
          />
          <v-text-field
            v-model="newNumberFields.passWord"
            label="Password"
            :rules="newNumberFieldsRules.passWord"
            required
            type="password"
          />
        </v-form>
        <div class="flex gap-2 items-center justify-end">
          <v-btn color="red" outlined @click="onCancelEditNumberClick">
            <span> Cancel </span>
          </v-btn>
          <v-btn :color="$vuetify.theme.currentTheme.primary"
              class="white--text" :loading="editingNumber" @click="handleEditNumber">
            <span v-if="editDialogVisible" class="text-white"> Edit </span>
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    receivedData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      phoneNumbers: [],
      addNumberDialogVisible: false,
      deleteDialogVisiblePhoneNumber: null,
      deleteDialogVisible: false,
      editingNumber: null,
      editDialogVisible: false,
      addingNumber: false,
      newNumberFields: {
        phoneNumber: "",
        userName: "",
        passWord: "",
      },
    };
  },
  mounted() {
    this.fetchAddedPhoneNumbers();
  },
  computed: {
    newNumberFieldsRules() {
      return {
        phoneNumber: [
          (v) => !!v || "Phone number is required",
        ],
        userName: [
          (v) => !!v || "Username is required",
        ],
        passWord: [
          (v) => !!v || "Password is required",
        ],
      };
    },
  },
  methods: {
    onEditNumberClick(phoneNumber) {
      this.newNumberFields = { ...phoneNumber };
      this.editDialogVisible = true;
    },
    onCancelEditNumberClick() {
      this.newNumberFields.phoneNumber = "";
      this.newNumberFields.userName = "";
      this.newNumberFields.passWord = "";
      this.editDialogVisible = false;
    },
    onDeleteNumberClick(phoneNumber) {
      this.deleteDialogVisiblePhoneNumber = this.phoneNumbers.find(
        (n) => n._id === phoneNumber._id
      );
      this.deleteDialogVisible = true;
    },
    onAddNumberClick() {
      this.addNumberDialogVisible = true;
    },
    async handleEditNumber() {
      this.editingNumber = true;
      try {
        const response = await this.$axios.put(
          `/workforce/tele-caller/credentials/${this.newNumberFields._id}`,
          {
            teleCaller: {
              phoneNumber: this.newNumberFields.phoneNumber,
              userName: this.newNumberFields.userName,
              passWord: this.newNumberFields.passWord,
            },
          },
        );
        this.phoneNumbers = this.phoneNumbers.map((n) => {
          if (n._id === response.data.teleCaller._id) {
            return response.data.teleCaller;
          }
          return n;
        });
        this.editDialogVisible = false;
        this.editingNumber = false;
      } catch (error) {
        const errorMessage = error.response.data.message || "Error editing phone number"
        this.$toast.error(errorMessage);
      }
    },
    async addNumber() {
      try {
        this.addingNumber = true;
        const response = await this.$axios.post(
          "/workforce/tele-caller/credentials",
          {
            teleCaller: {
              phoneNumber: this.newNumberFields.phoneNumber,
              userName: this.newNumberFields.userName,
              passWord: this.newNumberFields.passWord,
            }
          },
        );
        this.phoneNumbers.push(response.data.teleCaller);
        const successMessage = response?.data?.message || "Phone number added successfully"
        this.$toast.success(successMessage);

        this.newNumberFields.phoneNumber = "";
        this.newNumberFields.userName = "";
        this.newNumberFields.passWord = "";
      } catch (error) {
        this.$toast.error("Error adding phone number");
        const errorMessage = error.response.data.message || "Error adding phone number"
        this.$toast.error(errorMessage);
      }
      this.addNumberDialogVisible = false;
      this.addingNumber = false;
    },
    async deleteNumber(phoneNumber) {
      try {
        const response = await this.$axios.delete(
          `/workforce/tele-caller/credentials/${phoneNumber._id}`
        );
        const successMessage = response?.data?.message || "Phone number deleted successfully"
        this.$toast.success(successMessage);
        this.phoneNumbers = this.phoneNumbers.filter(
          (n) => n._id !== phoneNumber._id
        );
        this.deleteDialogVisiblePhoneNumber = null;
        this.deleteDialogVisible = false;
      } catch (error) {
        console.error("Error deleting phone number:", error);
        const errorMessage = error.response.data.message || error
        this.$toast.error(errorMessage);
      }
    },
    async fetchAddedPhoneNumbers() {
      try {
        const response = await this.$axios.get(
          "/workforce/tele-caller/credentials?orgId=DEVORG"
        );
        this.phoneNumbers = response.data.data;
      } catch (error) {
        console.error("Error fetching phone numbers:", error);
      }
    },
  },
};
</script>
